import axios from "axios";

const api = axios.create({ baseURL: "https://api.erdenet24.mn/shuudan" });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const signIn = (name, password) => api.post("/auth/signin", { name, password });

export const getDrivers = (params) => api.get("/drivers", { params });
export const getDriverByPhone = (phone) => api.get(`/drivers/${phone}`);
export const addDriver = (data) => api.post("/drivers", data);
export const getDriverBills = (params) => api.get("/drivers/bills", { params });

export const getPackages = (params) => api.get("/packages", { params });
export const getGroupedPackages = (params) => api.get("/packages/grouped", { params });
export const addPackages = (data) => api.post("/packages", data);
export const updatePackageStatus = (id, statusId) => api.put(`/packages/${id}/status`, { statusId });

export const getStatuses = () => api.get("/statuses");
export const getUsers = () => api.get("/users");
